const digest = '32faf49a003fdb18639e3291740242d8631fae74bc49a5d6ef81ca70037855aa';
const css = `._timeDropdownWrapper_1su9e_1{min-width:180px}._timeDropdownWrapper_1su9e_1 svg{margin-right:2px}._timeDropdown_1su9e_1>div:first-child{flex-grow:1}`;
(function() {
  if (global.BROWSER && !document.getElementById(digest)) {
    var el = document.createElement('style');
    el.id = digest;
    el.textContent = css;
    document.head.appendChild(el);
  }
})();
export default { 'timeDropdownWrapper': '_timeDropdownWrapper_1su9e_1', 'timeDropdown': '_timeDropdown_1su9e_1' };
export const timeDropdownWrapper = '_timeDropdownWrapper_1su9e_1';
export const timeDropdown = '_timeDropdown_1su9e_1';
export { css, digest };